import { Box, Typography } from '@mui/material';
import { ContentCard, Dropdown, ProgressCircle } from '../../components/UI';
import { useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { TaskService } from '../../Service/TaskService';
import { useAppDispatch } from '../../store/hooks';
import { createNotification } from '../../store/notifications/notification-slice';
import { Loading } from '../../components/Loading';
import { getLabelStatus } from '../../Utilis/getLabelStatus';

const Tasks = () => {
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();
  const [tasks, setTasks] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTasks();
  }, []);

  const getTasks = async () => {
    setIsLoading(true);
    try {
      const { data } = await TaskService.getTasks();

      setTasks(data);
    } catch (error) {
      appDispatch(
        createNotification({
          type: 'error',
          message: 'Something went wrong, try again later!',
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        padding: '32px 36px',
      }}
    >
      <Typography
        sx={{
          color: '#091E42',
          fontSize: '20px',
          fontWeight: '600',
          lineHeight: '32px',
          marginBottom: '8px',
        }}
      >
        Tasks
      </Typography>
      <Typography
        sx={{
          color: '#655C68',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '24px',
          marginBottom: '24px',
        }}
      >
        You can find here the list of tasks you need to complete
      </Typography>

      <Loading isLoading={isLoading}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {tasks.map(task => {
            const allQuestions = task.steps.reduce(
              (acc: number, curr: any) => acc + curr.questions,
              0
            );
            const completedQuestions = task.steps.reduce(
              (acc: number, curr: any) => acc + curr.completedQuestions,
              0
            );

            const label = getLabelStatus(allQuestions, completedQuestions, {
              relatedItem: 'tasks',
            });

            return (
              <Dropdown
                key={task.id}
                LeftHeaderComponent={
                  <ProgressCircle
                    size={32}
                    progress={(completedQuestions / allQuestions) * 100}
                  />
                }
                Header={
                  <ContentCard
                    title={task.name}
                    description='test'
                    label={label.text}
                    labelProps={{
                      color: label.color,
                      backgroundColor: label.backgroundColor,
                    }}
                  />
                }
                items={task.steps}
                renderItem={(step: any) => {
                  return (
                    <Box
                      key={step.id}
                      sx={{
                        display: 'flex',
                        gap: '15px',
                        padding: '15px 24px',
                        border: '1px solid #E3DDE6',
                        cursor: 'pointer',
                      }}
                      onClick={() => navigate(task.id + `?step=${step.id}`)}
                    >
                      <ContentCard
                        leftComponent={
                          <ProgressCircle
                            progress={
                              (step.completedQuestions / step.questions) * 100
                            }
                          />
                        }
                        size='sm'
                        title={step.name}
                        label={`See ${step.questions} tasks`}
                      />
                    </Box>
                  );
                }}
              />
            );
          })}
        </Box>
      </Loading>
    </Box>
  );
};

export default Tasks;
